import React from 'react'

/**
 * MarkupPanel — shared between Project Builder and Quote Builder
 * Saves directly to project on blur via onUpdate(field, value, save=true)
 */
export default function MarkupPanel({ project, onUpdate, borderless = false }) {
  if (!project) return null

  const matPct  = project.material_markup_pct ?? 20
  const labPct  = project.labour_markup_pct   ?? 0
  const vatReg  = project.vat_registered      ?? false

  const inner = (
    <>
      <div className="sum-label">Mark-up &amp; VAT</div>

      <div className="field">
        <span className="k">Materials</span>
        <div className="pct">
          <input
            type="number" min="0" max="200" step="1"
            value={matPct}
            onChange={e => onUpdate('material_markup_pct', e.target.value)}
            onBlur={e  => onUpdate('material_markup_pct', parseFloat(e.target.value) || 0, true)}
          />
          <span className="sign">%</span>
        </div>
      </div>

      <div className="field">
        <span className="k">Labour</span>
        <div className="pct">
          <input
            type="number" min="0" max="200" step="1"
            value={labPct}
            onChange={e => onUpdate('labour_markup_pct', e.target.value)}
            onBlur={e  => onUpdate('labour_markup_pct', parseFloat(e.target.value) || 0, true)}
          />
          <span className="sign">%</span>
        </div>
      </div>

      <div className="field">
        <span className="k">VAT</span>
        <button
          className={'toggle' + (vatReg ? ' on' : '')}
          onClick={() => onUpdate('vat_registered', !vatReg, true)}
        >
          <span className="knob" />
        </button>
      </div>
    </>
  )

  if (borderless) return <div>{inner}</div>

  return <div className="sum-group">{inner}</div>
}
